var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 80,
    viewBox: "0 0 148 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.906 63.8833C139.285 63.8075 139.664 63.7317 140.043 63.6559L141.786 33.9877L139.361 33.8362L137.58 63.8454C138.035 63.8833 138.489 63.8833 138.906 63.8833Z",
    fill: "#FE5B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.907 63.8833C139.286 63.8075 139.664 63.7318 140.043 63.656L141.786 33.9878L140.574 33.912L138.793 63.8454C138.869 63.8833 138.869 63.8833 138.907 63.8833Z",
    fill: "#FE8DAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.331 31.3733L140.194 31.2975L140.876 28.9862L141.331 31.3733Z",
    fill: "#0043EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.657 63.5044L146.749 35.9202L144.324 35.5792L140.156 63.656C140.99 63.5423 141.823 63.5423 142.657 63.5044Z",
    fill: "#0043EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.407 63.5423L145.537 35.7686L144.324 35.5792L140.156 63.656C140.573 63.6181 140.99 63.5802 141.407 63.5423Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.06 33.992L146.048 33.8422L146.009 34.1046L147.021 34.2544L147.06 33.992Z",
    fill: "#0043EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.904 34.9128L145.18 34.6577L145.141 34.92L146.865 35.1752L146.904 34.9128Z",
    fill: "#0043EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.128 33.3815L144.703 33.0026L145.158 30.0472C145.196 29.6683 145.537 29.4409 145.916 29.4788L147.052 29.6304C147.431 29.6683 147.659 30.0093 147.621 30.3882L147.128 33.3815Z",
    fill: "#FE8DAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7965 48.9924L29.9711 48.1967C29.9332 48.2346 29.9332 48.2725 29.8953 48.3103C29.5543 48.9166 29.2133 49.5228 28.7586 50.0533C27.8113 51.3037 26.6746 52.4404 25.2726 53.3498C25.2726 53.3498 25.2348 53.3498 25.2348 53.3877C25.2348 53.3877 25.2348 53.3877 25.1969 53.3877C25.1969 53.3877 25.159 53.3877 25.159 53.4256C23.9465 52.5541 22.8856 51.6068 22.0141 50.5838C19.3996 47.5525 18.1114 43.8772 18.1492 39.8229C18.1871 37.1706 18.7555 34.4046 19.8543 31.5628C21.0289 28.5694 22.8098 25.5003 25.1211 22.507C25.159 22.5448 25.159 22.5827 25.1969 22.5827V51.3416L26.4473 50.508L28.7965 48.9924Z",
    fill: "#FFBFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0042 42.9298C37.9663 43.0056 37.9285 43.1193 37.8906 43.1951C35.996 47.6282 32.9269 51.0384 28.7969 52.5919C27.698 53.0087 26.5234 53.3118 25.2731 53.4255H25.2352H25.1973C24.1363 51.4173 23.5301 49.3712 23.3406 47.363C23.2649 46.681 23.227 45.9989 23.2649 45.3169C23.3406 42.854 24.0227 40.4291 25.2352 38.1177V51.3415L26.4855 50.5079L28.7969 48.9923L29.9715 48.1966L38.0042 42.9298Z",
    fill: "#FDD790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4696 35.5791C50.1286 36.7537 49.7118 37.8904 49.2571 38.9892C49.0676 38.9892 48.8782 38.9513 48.7266 38.9513L48.6129 40.5048C44.2934 49.9774 36.7911 56.5704 28.8341 57.3282C27.6595 57.4418 26.447 57.4418 25.2724 57.2903C23.9463 57.1387 22.6201 56.7977 21.2939 56.2672C21.2939 55.6231 21.3318 55.0169 21.3697 54.3727C21.4076 53.7665 21.4834 53.1602 21.5971 52.554C21.7107 51.8719 21.8623 51.2278 22.0518 50.5837C22.3928 49.447 22.8096 48.3481 23.34 47.3251C23.4916 47.022 23.681 46.7189 23.8326 46.4157C24.2494 45.6958 24.742 45.0138 25.2345 44.3696V51.2657L26.4849 50.4321L28.7962 48.9165L29.9709 48.1208L37.9657 42.854L49.1813 35.4654C49.5981 35.5412 50.0528 35.5791 50.4696 35.5791Z",
    fill: "#FDD790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.485 50.5079C26.1819 51.4931 25.803 52.4403 25.3104 53.3876C25.3104 53.4255 25.2725 53.4255 25.2725 53.4634H25.2346H25.1967C23.9084 53.3118 22.6959 53.0466 21.5971 52.5919C15.6862 50.3185 11.8593 44.1423 10.7983 36.6021C10.3437 33.2678 10.3816 29.6682 11.0636 25.9928C14.5116 27.5842 17.505 29.4787 19.892 31.6006C22.2034 33.6088 23.9842 35.8064 25.2346 38.1556V51.3415L26.485 50.5079Z",
    fill: "#FFBFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2729 53.4634C15.0425 57.5177 4.09217 48.8029 0 35.5791C14.8152 34.8971 25.2729 41.7173 25.2729 53.4634Z",
    fill: "#FFBFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1641 74.4547H15.6869L17.3919 75.9703C19.1728 77.5238 21.2568 78.4711 23.4923 78.9637H8.33612L6.78261 64.5653L5.34277 51.3416H43.1953L40.1641 74.4547Z",
    fill: "#0043EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1637 74.4547H15.6865L17.3915 75.9703C19.1724 77.5238 21.2564 78.4711 23.4919 78.9637H8.33573L6.78223 64.5653L27.2809 51.3416H43.2328L40.1637 74.4547Z",
    fill: "#0020BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 56.9871L145.613 79.4183H128.373C132.351 79.4183 136.178 78.6226 139.134 75.9702L140.839 74.4546H111.322L110.564 69.3015L110.489 68.8468L109.958 65.2472L108.67 56.3051L127.994 56.6082L131.594 56.684L148 56.9871Z",
    fill: "#0043EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1891 3.94067L49.1819 35.5413L37.9664 42.9299L29.9715 48.1967L28.7969 48.9924V65.3232H128.032V3.94067H97.1891ZM61.0416 65.2474H48.9546V44.294C50.6975 44.4455 52.4784 44.4834 54.2592 44.4834C56.5706 44.4834 58.844 44.3698 61.0795 44.1424V65.2474H61.0416ZM76.9177 65.2474H64.8307V43.6498C68.9986 43.0057 73.0529 41.9827 76.9177 40.5807V65.2474ZM109.314 14.6258H107.609V12.5797C93.5516 30.3124 73.6212 40.846 53.9561 40.846C52.1753 40.846 50.3565 40.7702 48.6136 40.6565V40.5428L48.7272 38.9893C48.9167 38.9893 49.1061 39.0272 49.2577 39.0272C50.8112 39.1409 52.3647 39.1788 53.9561 39.1788C73.2802 39.1788 92.9075 28.6831 106.662 11.0641H104.009V9.35901H109.314V14.6258Z",
    fill: "#D9E3FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2354 0.378906V22.3175L28.7971 20.044V3.94061H128.032V65.2852H28.7971V49.0302L26.4857 50.5079L25.2354 51.3036V69.3395H131.632V0.378906H25.2354Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 68.8848H15.6865V74.4547H140.839V68.8848Z",
    fill: "#0043EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7852 76.0081H65.8154V77.9026H90.7852V76.0081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7852 76.0081H65.8154V77.9026H90.7852V76.0081Z",
    fill: "#0B45E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.67 17.278V65.2851H96.583V29.706C101.092 26.1064 105.184 21.9006 108.67 17.278Z",
    fill: "#FE5B88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7941 32.5099V65.2473H80.707V39.1408C84.9508 37.3599 89.005 35.1244 92.7941 32.5099Z",
    fill: "#FFBFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 142.651,
    y1: 38.5943,
    x2: 143.212,
    y2: 89.1304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C7CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1994,
    stopColor: "#4576F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5066,
    stopColor: "#2F66EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8814,
    stopColor: "#0C4CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#0043EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 50.2075,
    y1: 83.7458,
    x2: 106.657,
    y2: -14.0274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C7CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#4576F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#2F66EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8864,
    stopColor: "#0C4CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 79.4183,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.d0f44f4a05dbdff17f4cea12bdcc3558.svg";
export { ForwardRef as ReactComponent };